var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    enableBackground: "new 0 0 511.951 511.951",
    height: "512px",
    viewBox: "0 0 511.951 511.951",
    width: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m250.702 240.02c3.307 1.226 7.008 1.312 10.547 0l189.727-71.147v164.026c4.818-1.212 9.811-1.926 15-1.926s10.182.714 15 1.926v-175.277l21.273-7.603c12.923-4.858 12.948-23.228 0-28.096l-241-90c-3.399-1.26-7.149-1.26-10.547 0l-241 90c-12.923 4.858-12.948 23.228 0 28.096z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF7007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465.975 360.972c-25.649 0-45 32.241-45 75v30c0 8.291 6.709 15 15 15h60c8.291 0 15-6.709 15-15v-30c0-42.759-19.35-75-45-75z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF7007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.121 215.861-139.34 52.255c-10.437 3.855-21.473 3.753-31.509.029l-139.442-52.286c-12.512 45.854-9.33 75.947-9.855 85.113 0 10.611 10.785 17.856 20.552 13.931.352-.132 35.42-13.931 69.448-13.931 31.655 0 65.317 26.455 65.654 26.733 5.364 4.268 13.171 4.408 18.72-.015 9.288-7.441 39.185-26.719 65.626-26.719 34.028 0 69.097 13.799 69.448 13.931 9.744 3.916 20.552-3.3 20.552-13.931-.503-8.795 2.584-39.531-9.854-85.11z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF7007"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.7b2cdc05234a59302d5984e0d2fcf733.svg";
export { ForwardRef as ReactComponent };